<template>
    <b-container>
        <b-row>
            <div class="col-6">
                <b-table hover :items="categories" :fields="fields" ></b-table>
            </div>
            <div class="col-6">
                <b-form @submit="onSubmit">
                    <b-row>
                        <b-form-group  id="categoryInputGroup"
                                       horizontal
                                       :label-cols="3"
                                       label="Kategorie:"            
                                       label-for="categoryInput">
                            <b-form-input   id="categoryInput"
                                            type="text" 
                                            v-model="category.name"
                                            required>
                            </b-form-input>
                        </b-form-group>
                    </b-row>
                    <b-row>
                        <b-form-group label="Typ:"
                                      horizontal
                                      :label-cols="4">

                            <b-form-radio-group id="btnradios2"
                                                buttons
                                                button-variant="outline-primary"
                                                size="lg"
                                                v-model="category.type_name"
                                                :options="category_type_options"
                                                name="radioBtnOutline"
                                                required>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-row>
                    <b-row>
                        <b-button type="submit" variant="primary">speichern</b-button>
                    </b-row>
                </b-form>
            </div>
        </b-row>
    </b-container>
</template>

<script>
import {HTTP} from './http-common';
import AmplifyStore from '../store/store';

export default {
    name: 'CategoriesPage',
    data () {
        return {
            categories: [],
            category: {},
            fields: [{
                key: 'name',
                label: 'Name'
            },
            {
                key: 'type_name',
                label: 'Kategorietyp',
                sortable: true
            }],
            category_type_options: [{
                text: 'Galerie',
                value: 'Galerie'
            },
            {
                text: 'Kalender',
                value: 'Kalender'
            }]
        }
    },
    methods: {
        allPictures(){
            HTTP.get(`categories`)
            .then(response =>{
                this.categories = response.data;
            })
        },
        onSubmit(e){
            e.preventDefault(); 

            let createdCategory = {
                name: this.category.name,
                type_name: this.category.type_name
            }

            HTTP.post(
                `category`,
                JSON.stringify(createdCategory),
                {headers: {Authorization: `Bearer ${AmplifyStore.state.user.signInUserSession.idToken.jwtToken}`}}
            ).then( response => {
                this.$router.push({ name: 'CategoriesPage' })
            });
        }
    },
    created: function(){
        this.allPictures();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/CategoriesPage.vue